import { ApiProperty } from "@nestjs/swagger";

export class DistrictReq{
    @ApiProperty()
    district : string;
    @ApiProperty()
    state : string
}